import React from 'react';

import PropTypes from 'prop-types';

import './DataLabel.css';

const DataLabelC = ({ dataLabel, ...props }) => {

  return (
    <div
      className="data-label"
      {...props}
      automationid={`SalesLead_Div_${props.automationidattr}Label_0`}
    >
      {dataLabel}
    </div>
  )
}

DataLabelC.propTypes = {
  automationidattr: PropTypes.string,
  dataLabel: PropTypes.string,
};

const DataLabel = DataLabelC;

export default DataLabel;